import { render, staticRenderFns } from "./FuelsComponent.vue?vue&type=template&id=813a2048"
import script from "./FuelsComponent.vue?vue&type=script&lang=js"
export * from "./FuelsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports